import { PERMISSIONS } from '../helper/permissionHelper';

export const PERMISSION_GROUPS = [
  { label: PERMISSIONS.PENGUMUMAN, value: PERMISSIONS.PENGUMUMAN },
  {
    label: 'Master Data',
    options: [
      { label: PERMISSIONS.SHIFT, value: PERMISSIONS.SHIFT },
      { label: PERMISSIONS.JAM_KERJA, value: PERMISSIONS.JAM_KERJA },
      { label: PERMISSIONS.DIVISI, value: PERMISSIONS.DIVISI },
      { label: PERMISSIONS.JABATAN, value: PERMISSIONS.JABATAN },
      { label: PERMISSIONS.LOKASI_KUNJUNGAN, value: PERMISSIONS.LOKASI_KUNJUNGAN },
      { label: PERMISSIONS.LOKASI_KERJA, value: PERMISSIONS.LOKASI_KERJA },
      { label: PERMISSIONS.DAFTAR_ISTILLAH, value: PERMISSIONS.DAFTAR_ISTILLAH },
    ],
  },
  {
    label: 'Inventaris',
    options: [
      { label: PERMISSIONS.INVENTARIS, value: PERMISSIONS.INVENTARIS },
    ],
  },
  {
    label: 'Pengajuan Karyawan',
    options: [
      { label: PERMISSIONS.PENGAJUAN_IZIN, value: PERMISSIONS.PENGAJUAN_IZIN },
      { label: PERMISSIONS.PENGAJUAN_LEMBUR, value: PERMISSIONS.PENGAJUAN_LEMBUR },
      { label: PERMISSIONS.PENGAJUAN_KASBON, value: PERMISSIONS.PENGAJUAN_KASBON },
      { label: PERMISSIONS.PENGAJUAN_KLAIM_BEBAN, value: PERMISSIONS.PENGAJUAN_KLAIM_BEBAN },
      { label: PERMISSIONS.PENGAJUAN_INVENTARIS, value: PERMISSIONS.PENGAJUAN_INVENTARIS },
    ],
  },
  {
    label: 'Karyawan',
    options: [
      { label: PERMISSIONS.DAFTAR_KARYAWAN, value: PERMISSIONS.DAFTAR_KARYAWAN },
      { label: PERMISSIONS.DAFTAR_GAJI_KARYAWAN, value: PERMISSIONS.DAFTAR_GAJI_KARYAWAN },
      { label: PERMISSIONS.LAPORAN_CUTI, value: PERMISSIONS.LAPORAN_CUTI },
    ],
  },
  {
    label: 'Perusahaan',
    options: [
      { label: PERMISSIONS.KEUANGAN, value: PERMISSIONS.KEUANGAN },
    ],
  },
  {
    label: 'Presensi',
    options: [
      { label: PERMISSIONS.PRESENSI, value: PERMISSIONS.PRESENSI },
    ],
  },
  // { label: PERMISSIONS.AGENDA, value: PERMISSIONS.AGENDA },
  {
    label: 'Kunjungan',
    options: [
      { label: PERMISSIONS.KUNJUNGAN, value: PERMISSIONS.KUNJUNGAN },
    ],
  },
  {
    label: 'Tugas',
    options: [
      { label: PERMISSIONS.TUGAS, value: PERMISSIONS.TUGAS },
    ],
  },
  {
    label: 'Payroll',
    options: [
      { label: PERMISSIONS.DAFTAR_ISTILAH, value: PERMISSIONS.DAFTAR_ISTILAH },
      { label: PERMISSIONS.DAFTAR_PAYROLL, value: PERMISSIONS.DAFTAR_PAYROLL },
      { label: PERMISSIONS.PENGATURAN_PAYROLL, value: PERMISSIONS.PENGATURAN_PAYROLL },
    ],
  },
  { label: PERMISSIONS.PEMBAYARAN_KASBON, value: PERMISSIONS.PEMBAYARAN_KASBON },
  { label: PERMISSIONS.LANGGANAN, value: PERMISSIONS.LANGGANAN },
  { label: PERMISSIONS.PENGATURAN, value: PERMISSIONS.PENGATURAN },
  { label: PERMISSIONS.PEMANTAUAN, value: PERMISSIONS.PEMANTAUAN },
];
